import appConfig from "../config/app.config";
import axios from "axios";
import { getUserToken } from "../libs/user";
import { fireReloginPopup, getPureJSON, handleError } from "../libs/utils";

const getFAQList = () => {
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: appConfig.apiUrl.getfaqList,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          fireReloginPopup();
          return;
        }
        reject(error);
      });
  });
};

const getFaqDataById = (id) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: `${appConfig.apiUrl.getfaqList}/${id}`,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        handleError({ error, reject });
      });
  });
};

const updateFaqdata = (obj) => {
  const authToken = getUserToken();
  return new Promise((resolve, reject) => {
    var data = JSON.stringify({
      objectId: obj.objectId,
      id: obj.id,
      question: obj.question,
      answer: obj.answer,
      popularity: obj.popularity,
      isActive: obj.isActive,
      promoType: obj.promoType,
      offerIdList: obj.offerIdList,
    });

    var config = {
      method: "post",
      url: `${appConfig.apiUrl.getfaqList}/save`,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        handleError({ error, reject });
      });
  });
};

const deleteFaq = (id) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "delete",
      url: `${appConfig.apiUrl.deletefaq}/${id}`,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        handleError({ error, reject });
      });
  });
};

export { getFAQList, getFaqDataById, updateFaqdata, deleteFaq };
